import React, { useState } from 'react';

import PrimaryButton from '../../shared/buttons/PrimaryButton';

const PostApprovalAccountPicker = ({ accounts, onSubmit, disabled }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const submit = (event) => {
    event.preventDefault();
    if (selectedIndex !== null) {
      Promise.resolve(onSubmit(selectedIndex)).catch(() => undefined);
    }
  };

  return (
    <form onSubmit={submit}>
      <fieldset className="space-y-3" disabled={disabled}>
        <legend className="mb-2 text-sm font-semibold">Choose an account</legend>
        {accounts.map((account) => (
          <label
            className="flex cursor-pointer items-center gap-3 rounded-lg border border-gray-300 p-3"
            key={account.index}
          >
            <input
              checked={selectedIndex === account.index}
              name="post-approval-account"
              onChange={() => setSelectedIndex(account.index)}
              type="radio"
              value={account.index}
            />
            <span>
              {account.label}
              {account.subtype ? ` (${account.subtype})` : ''}
            </span>
          </label>
        ))}
      </fieldset>
      <PrimaryButton
        buttonColor="bg-primary"
        buttonText="Submit"
        disabled={disabled || selectedIndex === null}
        isLoading={disabled}
      />
    </form>
  );
};

export default PostApprovalAccountPicker;
